var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.818 10.1968L3.28601 11.4528C3.19942 11.4673 3.11815 11.5043 3.05039 11.5601C2.98263 11.6159 2.93077 11.6886 2.90001 11.7708L0.30301 18.7278C0.0550096 19.3678 0.72401 19.9778 1.33801 19.6708L19.338 10.6708C19.4627 10.6086 19.5675 10.5128 19.6408 10.3943C19.7141 10.2758 19.753 10.1392 19.753 9.99984C19.753 9.86049 19.7141 9.72389 19.6408 9.60537C19.5675 9.48685 19.4627 9.39109 19.338 9.32884L1.33801 0.32884C0.72401 0.0218396 0.0550096 0.63284 0.30301 1.27184L2.90101 8.22884C2.93162 8.31125 2.98343 8.38414 3.0512 8.44014C3.11897 8.49615 3.2003 8.5333 3.28701 8.54784L10.819 9.80284C10.8654 9.81096 10.9074 9.83516 10.9376 9.8712C10.9679 9.90723 10.9845 9.95278 10.9845 9.99984C10.9845 10.0469 10.9679 10.0925 10.9376 10.1285C10.9074 10.1645 10.8654 10.1887 10.819 10.1968H10.818Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3352f7302b7cf034a115b374aaeee360.svg";
export { ForwardRef as ReactComponent };